import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { LoadableLazy } from '@confluence/loadable';
import React from 'react';

const TrialFlagsLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TrialComponentsFlags" */ '../src/TrialFlags/TrialFlags.tsx'
			)
		).TrialFlags,
});

export const TrialFlags: React.FC<{}> = withErrorBoundary({
	attribution: Attribution.GROWTH_LUNA,
})(() => <TrialFlagsLoadable />);
